
export class HeaderTypeButtonDualPickListModel{

  onClick:()=>{};
/**
 * @param {?=} onClickFn
 */
constructor(onClickFn = null) {
    this.onClick = onClickFn;
  }


}

function HeaderTypeButtonDualPickListModel_tsickle_Closure_declarations() {
/** @type {?} */
HeaderTypeButtonDualPickListModel.prototype.onClick;
}

